import {Component, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Dialog, DialogGroups } from 'app/dialogs';
import { DialogsService } from 'app/dialogs/services/dialogs.service';
import { UserProfile, UserRole } from 'app/profile/model/model';
import { UserService } from 'app/profile/services/user.service';

import {Md5} from 'ts-md5';

import { Browser } from '@capacitor/browser';

import {NavService} from 'shared/nav/nav.service';
import { LoginService } from 'app/login/services/login.service';

@Component({
  selector: 'profile-page',
  templateUrl: 'profile-page.html',
  styleUrls: ['profile-page.scss'],
})
export class ProfilePage implements OnInit {

  public lineY = '';

  constructor(
    public navService: NavService,
    private loginService: LoginService,
    private userService: UserService,
    private translateService: TranslateService,
  ) {
    if ( navService.get('lineY') !== undefined ) {
      this.lineY = (navService.get('lineY')-56-24)+'px'; // TODO: Header-Höhe und halbe Itemhöhe
      // console.log("## "+navService.get('lineY')+'px');
    }
  }

  public ngOnInit(): void {
  }

  public showPositionPage(): void {
    this.navService.push('onboarding/position', {isFromMenu: true});
  }

  public showPasswordSetPage(): void {
    this.navService.push('profile/passwordset');
  }

  public logout(): void {
    this.loginService.logout().subscribe((success) => {
      this.navService.root('login', {autoLogin: false});
    });
  }

  public unregister(): void {
    this.userService.getUserProfile('full')
    .subscribe((profile: UserProfile) => {
      Browser.open({url: 'https://register.leada.de/unregister/'+profile.email+'?code='+Md5.hashStr(profile._id)+'&lang='+this.translateService.currentLang});
    });
  }

  public goBack(): void {
    this.navService.pop();
  }

  public showSettings(): void {
    this.navService.push('profile/settings');
  }

  public showSearch(): void {
    this.navService.push('/search');
  }

}
